import {Kind} from "graphql";

export default function unguard(fields) {
    fields = Array.isArray(fields) ? fields : [fields];
    const directive = {
        kind: Kind.DIRECTIVE,
        name: { kind: Kind.NAME, value: 'unguard' },
        arguments: []
    }
    return ({typeDefs, resolvers}) => {
        fields.forEach(f => {
            const path = f.split('.');
            if (path.length < 2) {
                path.unshift('Mutation')
            }
            let typeIndex = typeDefs.definitions.findIndex(d => d.name?.value === path[0]);
            if (typeIndex) {
                // path cannot be longer
                if (path[1]) {
                    const fieldIndex = typeDefs.definitions[typeIndex].fields.findIndex(f => f.name?.value === path[1]);
                    typeDefs.definitions[typeIndex].fields[fieldIndex].directives.push(directive)
                } else {
                    typeDefs.definitions[typeIndex].directives.push(directive)
                }
            }

        })
        return {typeDefs, resolvers};
    }
}
